'use strict';

var ImageQueueMixin = require('./ImageQueueMixin'),
    ResponsiveImageMixin = require('./ResponsiveImageMixin');

/**
 * Manages state of a sequential image queue.
 * Define `getImageSizes` to specify image sizes for media queries.
 *
 * Use `ImageQueueMixin` instead if you need fine control
 * over requested width and if you are not content with
 * specifying widths for different @media-* queries, or use
 * `FlexibleImageQueueMixin` if you want the requested width
 * to match DOM element's offsetWidth.
 */
var ResponsiveImageQueueMixin = {
  mixins: [ImageQueueMixin, ResponsiveImageMixin],

  componentDidUpdate: function (prevProps, prevState) {
    if (prevState.imageSize !== this.state.imageSize) {
      this.updateImageQueue();
    }
  },

  getNormalImageSize: function () {
    return {
      width: this.state.imageSize
    };
  }
};

module.exports = ResponsiveImageQueueMixin;


/** WEBPACK FOOTER **
 ** ./mixins/ResponsiveImageQueueMixin.js
 **/